import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";
import { RouterProvider } from "react-router";

type DatadogRouterProviderProps = {
	readonly router: Parameters<typeof RouterProvider>[0]["router"];
};

/**
 * RouterProvider wrapper that integrates with Datadog RUM for route tracking.
 * This ensures navigation events are properly tracked by Datadog.
 */
export function DatadogRouterProvider({ router }: DatadogRouterProviderProps) {
	useEffect(() => {
		// Track route changes manually for Datadog RUM
		const handleRouteChange = () => {
			const currentPath = globalThis.location.pathname;
			datadogRum.startView(currentPath);
		};

		// Track initial route
		handleRouteChange();

		// Listen for popstate events (back/forward navigation)
		globalThis.addEventListener("popstate", handleRouteChange);

		return () => {
			globalThis.removeEventListener("popstate", handleRouteChange);
		};
	}, []);

	return <RouterProvider router={router} />;
}
